<template>
	<footer
		class="footer"
		:class="{ [`footer-${type}`]: type }"
		:data-background-color="backgroundColor"
	>
		<div class="container">
			<nav>
				<ul>
					<li>
						<a href="/impressum">
							Impressum
						</a>
					</li>
				</ul>
			</nav>
			<div
				@mouseover="mouseEnter"
				@mouseleave="mouseLeave"
				v-show="!swapOnHover"
			>
				<div class="copyright">&copy; {{ year }} sevendaystocope</div>
			</div>
			<div v-show="swapOnHover">
				<div class="copyright">&copy; {{ year }} sevendaystocode</div>
			</div>
		</div>
	</footer>
</template>
<script>
export default {
	props: {
		backgroundColor: String,
		type: String,
	},
	data() {
		return {
			year: new Date().getFullYear(),
			swapOnHover: false,
		};
	},
	methods: {
		mouseEnter: function() {
			setTimeout(
				function() {
					this.swapOnHover = !this.swapOnHover;
				}.bind(this),
				1000
			);
		},
		mouseLeave: function() {
setTimeout(
				function() {
			this.swapOnHover = false;
				}.bind(this),
				1000
			);
		},
	},
};
</script>
<style></style>
